export default "__VITE_ASSET__BwC5mcVY__"